import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AssignmentRole } from '@completion/models';
import { AssignmentRoleType } from 'src/app/shared/enums/assignment-role-type';

export interface AssignmentRoleEditDialogData {
  role: AssignmentRole;
}

@Component({
  selector: 'app-assignment-role-edit-dialog',
  templateUrl: './assignment-role-edit-dialog.component.html',
  styleUrls: ['./assignment-role-edit-dialog.component.scss'],
  standalone: false,
})
export class AssignmentRoleEditDialogComponent {
  form: FormGroup;
  assignmentRoleType = AssignmentRoleType; // expose enum to template
  assignmentRoleTypes = Object.values(AssignmentRoleType); // for @for in template

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<AssignmentRoleEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AssignmentRoleEditDialogData,
  ) {
    const role: AssignmentRole = data?.role || ({} as AssignmentRole);
    this.form = this.fb.group({
      id: [role.id],
      name: [role.name || '', [Validators.required, Validators.maxLength(100)]],
      description: [role.description || '', [Validators.maxLength(255)]],
      sharedEmail: [role.sharedEmail || '', [Validators.email, Validators.maxLength(255)]],
      type: [role.type || AssignmentRoleType.PUNCH, [Validators.maxLength(100)]],
      sendToAll: [role.sendToAll ?? false],
    });
  }

  save(): void {
    if (this.form.valid) {
      const value: AssignmentRole = this.form.value;
      this.dialogRef.close(value);
    } else {
      this.form.markAllAsTouched();
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
